import Cookies from 'js-cookie'

import { getCountryCode } from 'base/lib/localization'
import { SHOW_GDPR_EMAIL_OPTIN } from 'cookies.yml'

function isGDPRCountryCode(countryCode) {
  return [
    'AT',
    'BE',
    'BG',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GB',
    'GF',
    'GP',
    'GR',
    'HR',
    'HU',
    'IE',
    'IS',
    'IT',
    'LI',
    'LT',
    'LU',
    'LV',
    'MF',
    'MQ',
    'MT',
    'NL',
    'NO',
    'PL',
    'PT',
    'RE',
    'RO',
    'SE',
    'SI',
    'SK',
    'YT',
  ].includes(countryCode)
}

export function isInGDPRCountry() {
  const countryCode = getCountryCode()
  return isGDPRCountryCode(countryCode)
}

export function requiresGDPRConsent() {
  return isInGDPRCountry() && Cookies.get(SHOW_GDPR_EMAIL_OPTIN) !== 'false'
}

export function isInternational() {
  return getCountryCode() !== 'US'
}
